module.exports = __webpack_public_path__ + "static/img/checkIns-count.53818d8b.png";